import { Stack } from "@mui/material";
import NonMHDContinue from "app/frontend/components/eligibility/accordions/confirmation/NonMHDContinue";
import { useProjectParams } from "app/frontend/hooks/usePropsParams";
import { useMemo } from "react";

export const useProjectConfirmationLightDuty = () => {
    const projectParams = useProjectParams();
    const plugCount = Number(projectParams?.plugs?.[0]?.count || 0);

    const body = useMemo(() => {
        return (
            <Stack direction={"column"} gap={1}>
                <NonMHDContinue
                    header={
                        plugCount < 2
                            ? "Contact a Con Edison Advisor for guidance with your eligibility."
                            : "Based on your project details, your project may be eligible for PowerReady Light-Duty Incentives. Visit the Incentive Calculator to learn more."
                    }
                />
            </Stack>
        );
    }, [plugCount]);

    return () => ({
        h2:
            plugCount < 2
                ? "You May Be Eligible for Con Edison Incentives."
                : "You May Be Eligible for PowerReady Light-Duty Incentives.",
        body: body,
    });
};
